import { collection, getDocs, query, setDoc, updateDoc, doc, deleteDoc, where } from "@firebase/firestore";
import { db } from '../../firebase_config';
import { ENTERPRISE_COLLECTION, Enterprise } from "../../type";

class EnterpriseService {
  async getAllEnterprises(): Promise<Enterprise[]> {
    const q = query(collection(db, ENTERPRISE_COLLECTION));
    const snap = await getDocs(q);
    return snap.docs.map(doc => ({ 
      ...doc.data(),
      enterpriseId: doc.id 
    } as Enterprise));
  }

  async getEnterpriseById(enterpriseId: string): Promise<Enterprise | null> {
    const q = query(collection(db, ENTERPRISE_COLLECTION), where('enterpriseId', '==', enterpriseId));
    const snap = await getDocs(q);
    const doc = snap.docs[0];
    return doc ? { 
      ...doc.data(),
      enterpriseId: doc.id 
    } as Enterprise : null;
  }

  async createEnterprise(enterprise: Enterprise): Promise<void> {
    await setDoc(doc(db, ENTERPRISE_COLLECTION, enterprise.enterpriseId), enterprise);
  }

  async updateEnterprise(enterpriseId: string, enterprise: Partial<Enterprise>): Promise<void> {
    const { enterpriseId: _, ...enterpriseData } = enterprise;
    await updateDoc(doc(db, ENTERPRISE_COLLECTION, enterpriseId), enterpriseData);
  }

  async deleteEnterprise(enterpriseId: string): Promise<void> {
    await deleteDoc(doc(db, ENTERPRISE_COLLECTION, enterpriseId));
  }
}

export default new EnterpriseService();